import { Box, Container, LinearProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { GetLocalUser } from 'src/actions/AuthActions';
import {
  LessonsGetTypes,
  GetTutorLessons
} from 'src/actions/LessonActions';
import Footer from 'src/components/Footer';
import UnpaidTutorsTable from './UnpaidTutorsTable';

const DashboardPayroll = () => {
  const [lessonData, setLessonData] = useState<LessonsGetTypes>();
  // const [studentsData, setStudentData] = useState<StudentsGetTypes>();
  const dispatch = useDispatch();

  let user = GetLocalUser();

  //Initial Load
  useEffect(() => {
    //If there is a user id in the url params
    if (user != null) {
      dispatch<any>(GetTutorLessons(setLessonData, null, 'tutor_unpaid',['completed']));
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Payroll</title>
      </Helmet>

      <Box pt={2} />

      <Container maxWidth="lg">
        <h1>Payroll</h1>

        {lessonData && lessonData.type == 'Success' ? (
          <UnpaidTutorsTable lessons={lessonData.payload} />
        ) : (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default DashboardPayroll;
